import React, { Component } from "react";
import "w3-css/3/w3.css";

class FromAcreButton extends Component {
  handleClickButon = buttonId => {
    this.props.acUnit(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Acre to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <HectareButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <SquareFootButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <SquareInchButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <SquareMeterButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <SquareMileButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <SquareYardButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromHectareButton extends Component {
  handleClickButon = buttonId => {
    this.props.heUnit(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Hectare to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <AcreButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <SquareFootButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <SquareInchButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <SquareMeterButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <SquareMileButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <SquareYardButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromSquareFootButton extends Component {
  handleClickButon = buttonId => {
    this.props.ftUnit(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Square Foot to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <AcreButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <HectareButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <SquareInchButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <SquareMeterButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <SquareMileButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <SquareYardButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromSquareInchButton extends Component {
  handleClickButon = buttonId => {
    this.props.inUnit(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Square Inch to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <AcreButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <HectareButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <SquareFootButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <SquareMeterButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <SquareMileButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <SquareYardButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromSquareMeterButton extends Component {
  handleClickButon = buttonId => {
    this.props.mUnit(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Square Meter to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <AcreButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <HectareButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <SquareFootButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <SquareInchButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <SquareMileButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <SquareYardButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromSquareMileButton extends Component {
  handleClickButon = buttonId => {
    this.props.miUnit(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Square Mile to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <AcreButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <HectareButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <SquareFootButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <SquareInchButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <SquareMeterButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <SquareYardButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromSquareYardButton extends Component {
  handleClickButon = buttonId => {
    this.props.ydUnit(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Square Yard to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <AcreButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <HectareButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <SquareFootButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <SquareInchButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <SquareMeterButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <SquareMileButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class AcreButton extends Component {
  handleUpButton = () => {
    let name = "ac";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="acre"
        >
          Acres
        </button>
      </span>
    );
  }
}

class SquareFootButton extends Component {
  handleUpButton = () => {
    let name = "ft";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="squarefoot"
        >
          Square Feet
        </button>
      </span>
    );
  }
}

class HectareButton extends Component {
  handleUpButton = () => {
    let name = "he";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="hectare"
        >
          Hectares
        </button>
      </span>
    );
  }
}

class SquareInchButton extends Component {
  handleUpButton = () => {
    let name = "in";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="squareinch"
        >
          Square Inches
        </button>
      </span>
    );
  }
}

class SquareMeterButton extends Component {
  handleUpButton = () => {
    let name = "m";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="squaremeter"
        >
          Square Meters
        </button>
      </span>
    );
  }
}

class SquareMileButton extends Component {
  handleUpButton = () => {
    let name = "mi";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="squaremile"
        >
          Square Miles
        </button>
      </span>
    );
  }
}

class SquareYardButton extends Component {
  handleUpButton = () => {
    let name = "yd";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="squareyard"
        >
          Square Yards
        </button>
      </span>
    );
  }
}

export {
  FromAcreButton,
  FromHectareButton,
  FromSquareFootButton,
  FromSquareInchButton,
  FromSquareMeterButton,
  FromSquareMileButton,
  FromSquareYardButton
};
